const Utils = require("common/Utils");

function ServerConfiguration(settings) {
    let session = undefined;

    this.setServerConfig = function(settings) {
        this.hostname = settings.hostname;
        this.authType = settings.authType;
        this.customLogo = settings.customLogo;
        this.customTheme = settings.customTheme;
        this.version = settings.version;
        this.allowRememberMe = settings.allowRememberMe;
        this.passwdLabel = settings.passwdLabel;
        this.infoFileName = settings.infoFileName;
        this.welcomeText = settings.welcomeText;
        this.performNAC = settings.performNAC;
        this.identity = settings.identity;
    };

    this.setServerConfig(settings);

    this.createSession = function(key, token, username, password, customVpnAllowed, enrolledForTOTP, totpEnabled) {
        session = {
            key : key,
            token : token,
            username : username,
            password : password,
            customVpnAllowed : customVpnAllowed,
            enrolledForTOTP : enrolledForTOTP,
            totpEnabled : !!totpEnabled,
            totpSelfEnroll : !!totpEnabled,
            completedAuthSchemes : {}
        };

        return session;
    };

    this.getSession = function() {
        return session;
    };

    this.setSession = function(sess) {
        session = sess;
    };

    this.clearSession = function() {
        if (Utils.isGreaterThanOrEqualToServerVersion(this.version, "7.1.0")) {
            session = {
                key : session.key,
                token : session.token,
                completedAuthSchemes : {}
            };
        } else {
            session = undefined;
        }
    };
}

module.exports = ServerConfiguration;



//////////////////
// WEBPACK FOOTER
// ./common/ServerConfiguration.js
// module id = 36
// module chunks = 3 4